export const MyFunctions = {
    colors_Gr: function(data) {

        if(0<= data && data< 0.11){
          return '#3d4ebe'
        }
        if(0.11<= data && data< 0.21 ){
          return '#5a77df'
        }
        if(0.21<= data && data< 0.31 ){
          return '#7fa1f7'
        }
        if(0.31<= data && data < 0.41){
          return '#9fbffc'
        }
        if(0.41<= data && data < 0.51){
          return '#c0d3f3'
        }
        if(0.51<= data && data < 0.61){
          return '#d5dbe4'
        }
        if(0.61<= data && data < 0.71){
          return '#f5a98e'
        }
        if(0.71<= data && data < 0.81){
          return '#eb8068'
        }
        if(0.81<= data && data < 0.91){
          return '#d75549'
        }
        if(0.91<= data && data <= 1){
          return '#b60e2c'
        }
      },
  };